<template>
  <div class="range-container">
    <div class="date-container">
      <div class="margin-left-16">
        <span class="sac__font-14">From:</span>
        <span class="sac__font-14 med margin-left-4">{{ newSelectedDate.start | dateFormat }}</span>
      </div>
    </div>
    <div class="date-container">
      <div>
        <span class="sac__font-14">To:</span>
        <span class="sac__font-14 med margin-left-4">{{ newSelectedDate.end | dateFormat }}</span>
      </div>
      <div class="date-picker">
        <Datepicker
          v-model="newSelectedDate"
          mode="range"
          :max-date="new Date()"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'v-calendar/lib/components/date-picker.umd';
import serviceMixin from '@shared/mixins/serviceMixin';

export default {
  name: 'CustomDateRangeFilter',
  components: {
    Datepicker,
  },
  filters: {
    dateFormat(value) {
      if (!value) return '--';
      const date = new Date(value);
      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
    },
  },
  mixins: [
    serviceMixin,
  ],
  props: {
    type: String,
  },
  data() {
    return {
      newSelectedDate: {
        start: null,
        end: null,
      },
    };
  },
  watch: {
    newSelectedDate(newValue) {
      this.updateDateRangeFilter(newValue, this.type);
    },
  },
};

</script>
<style lang="scss" scoped>
.range-container {
  display: flex;
  align-items: center;
  padding: 4px;
  background-color: $N5;
  border-radius: 8px;
  width: 400px;
  .date-container {
    display: flex;
    align-items: center;

    .date {
      display: flex;
      align-items: center;

      .label {
        font-weight: bold;
        margin-right: 4px;
      }

      .date-text {
        font-size: 12.64px;
      }
    }
  }

  .date-container + .date-container {
    margin-left: 20px;
  }

  .date-picker {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;

    input {
      opacity: 0;
    }
  }
}
</style>
